// Connection + offline-queue status for the top bar. Green when the live stream is
// open, amber while connecting, grey when offline; shows a pending-mutation count when
// the offline queue holds unsynced writes. Makes F8's plumbing visible at a glance.
import { useLiveStatus } from '../lib/useLive.ts';
import { useQueueStatus } from '../lib/useQueue.ts';
import { t } from '../i18n/index.ts';

export function SyncIndicator() {
  const status = useLiveStatus();
  const { pending } = useQueueStatus();

  const dot =
    status === 'open'
      ? 'bg-accent'
      : status === 'connecting'
        ? 'bg-status-progress-fg'
        : 'bg-status-urgent-fg';
  const label =
    status === 'open' ? t('sync.live') : status === 'connecting' ? t('sync.connecting') : t('sync.offline');

  return (
    <div
      className="inline-flex items-center gap-1.5 rounded-full bg-surface-2/70 px-2.5 py-1 text-[11px] font-medium text-muted"
      title={label}
    >
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${dot}`} aria-hidden />
      <span className="hidden sm:inline">{label}</span>
      {pending > 0 && (
        <span className="tabnum rounded-full bg-surface px-1.5 text-ink">
          {t('sync.pending', { count: pending })}
        </span>
      )}
    </div>
  );
}
